export default "__VITE_ASSET__SdmeWT76__"